// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0px;
    background: #f1f1f1;
}

.vcenter {
    margin-top: 300%;
    height: 100%;
}

.vertical-align {
    display: flex;
    align-items: center;
}

.login-page {
    background: #FFFFFF;
    height: 100%;
}

.login-form {
    height: 100%;
    width: 80%;
}

.ui.toggle.checkbox .box:before,
.ui.toggle.checkbox label:before {
    background: rgba(0, 0, 0, 0.27);
}

.ui.toggle.checkbox .box:after,
.ui.toggle.checkbox label:after {
    border: 1px solid #e1e1e1;
}

.headerless .rt-tr-group {
    flex: none;
}

.headerless .rt-thead.-header {
    display: none;
}

.-pagination {
    height: 50px;
}

.ui.table td {
    padding: 6px 6px;
}

.twoColumnCard>canvas {
    margin-left: 40px;
    width: 200px !important;
    height: 200px !important;
}

.DayPickerInput input {    
    margin: 0;
    max-width: 100%;
    -webkit-box-flex: 1;
    -ms-flex: 1 0 auto;
    flex: 1 0 auto;
    outline: 0;
    -webkit-tap-highlight-color: rgba(255,255,255,0);
    text-align: left;
    line-height: 1.21428571em;
    font-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif;
    padding: .67857143em 1em;
    background: #fff;
    border: 1px solid rgba(34,36,38,.15);
    color: rgba(0,0,0,.87);
    border-radius: .28571429rem;
    -webkit-transition: border-color .1s ease,-webkit-box-shadow .1s ease;
    transition: border-color .1s ease,-webkit-box-shadow .1s ease;
    transition: box-shadow .1s ease,border-color .1s ease;
    transition: box-shadow .1s ease,border-color .1s ease,-webkit-box-shadow .1s ease;
    -webkit-box-shadow: none;
    box-shadow: none;
}

.DayPickerInput-OverlayWrapper div {
    z-index: 1000;
}

/* As the default pointing color(black) is applied to tab items we are overriding it the match the custom theme (teal) */
#pandgQuestionarie .ui.inverted.pointing.menu .active.item:after,
#pandgQuestionarie .ui.inverted.pointing.menu .active.item:hover:after {
    background: #00a39b !important;
}

.react-table-dropdown {
    min-height: 28px !important;
    max-height: 28px !important;
    line-height: 0em !important;
    border-radius: 0px !important;
    position: fixed !important;
    width: 150px !important;
    border: 1px solid rgba(0, 0, 0, 0.1) !important;
}

.react-table-dropdown input{
    height: 100% !important;
    padding: 0 !important;
}

.react-table-dropdown div{
    vertical-align: sub !important;
    /* text-align: left; */
    /* inline-size: max-content; */
}

.react-table-dropdown i{
    padding: 6px !important
}`, "",{"version":3,"sources":["webpack://./styles/main.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,gDAAgD;IAChD,gBAAgB;IAChB,yBAAyB;IACzB,6DAA6D;IAC7D,wBAAwB;IACxB,gBAAgB;IAChB,oCAAoC;IACpC,sBAAsB;IACtB,2BAA2B;IAC3B,qEAAqE;IACrE,6DAA6D;IAC7D,qDAAqD;IACrD,iFAAiF;IACjF,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA,wHAAwH;AACxH;;IAEI,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,6BAA6B;IAC7B,0BAA0B;IAC1B,uBAAuB;IACvB,+CAA+C;AACnD;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI;AACJ","sourcesContent":["body {\n    margin: 0px;\n    background: #f1f1f1;\n}\n\n.vcenter {\n    margin-top: 300%;\n    height: 100%;\n}\n\n.vertical-align {\n    display: flex;\n    align-items: center;\n}\n\n.login-page {\n    background: #FFFFFF;\n    height: 100%;\n}\n\n.login-form {\n    height: 100%;\n    width: 80%;\n}\n\n.ui.toggle.checkbox .box:before,\n.ui.toggle.checkbox label:before {\n    background: rgba(0, 0, 0, 0.27);\n}\n\n.ui.toggle.checkbox .box:after,\n.ui.toggle.checkbox label:after {\n    border: 1px solid #e1e1e1;\n}\n\n.headerless .rt-tr-group {\n    flex: none;\n}\n\n.headerless .rt-thead.-header {\n    display: none;\n}\n\n.-pagination {\n    height: 50px;\n}\n\n.ui.table td {\n    padding: 6px 6px;\n}\n\n.twoColumnCard>canvas {\n    margin-left: 40px;\n    width: 200px !important;\n    height: 200px !important;\n}\n\n.DayPickerInput input {    \n    margin: 0;\n    max-width: 100%;\n    -webkit-box-flex: 1;\n    -ms-flex: 1 0 auto;\n    flex: 1 0 auto;\n    outline: 0;\n    -webkit-tap-highlight-color: rgba(255,255,255,0);\n    text-align: left;\n    line-height: 1.21428571em;\n    font-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif;\n    padding: .67857143em 1em;\n    background: #fff;\n    border: 1px solid rgba(34,36,38,.15);\n    color: rgba(0,0,0,.87);\n    border-radius: .28571429rem;\n    -webkit-transition: border-color .1s ease,-webkit-box-shadow .1s ease;\n    transition: border-color .1s ease,-webkit-box-shadow .1s ease;\n    transition: box-shadow .1s ease,border-color .1s ease;\n    transition: box-shadow .1s ease,border-color .1s ease,-webkit-box-shadow .1s ease;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n}\n\n.DayPickerInput-OverlayWrapper div {\n    z-index: 1000;\n}\n\n/* As the default pointing color(black) is applied to tab items we are overriding it the match the custom theme (teal) */\n#pandgQuestionarie .ui.inverted.pointing.menu .active.item:after,\n#pandgQuestionarie .ui.inverted.pointing.menu .active.item:hover:after {\n    background: #00a39b !important;\n}\n\n.react-table-dropdown {\n    min-height: 28px !important;\n    max-height: 28px !important;\n    line-height: 0em !important;\n    border-radius: 0px !important;\n    position: fixed !important;\n    width: 150px !important;\n    border: 1px solid rgba(0, 0, 0, 0.1) !important;\n}\n\n.react-table-dropdown input{\n    height: 100% !important;\n    padding: 0 !important;\n}\n\n.react-table-dropdown div{\n    vertical-align: sub !important;\n    /* text-align: left; */\n    /* inline-size: max-content; */\n}\n\n.react-table-dropdown i{\n    padding: 6px !important\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
